<ng-content select="[slot=header]"></ng-content>
<div class="base-content">
  <ng-content #baseContent></ng-content>
</div>
<ng-content select="[slot=footer]"></ng-content>
